import { render, staticRenderFns } from "./BillingsTable.vue?vue&type=template&id=28adf96f"
import script from "./BillingsTable.vue?vue&type=script&lang=js"
export * from "./BillingsTable.vue?vue&type=script&lang=js"
import style0 from "./BillingsTable.vue?vue&type=style&index=0&id=28adf96f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports